import { render, staticRenderFns } from "./conError.vue?vue&type=template&id=1d451299&scoped=true"
import script from "./conError.vue?vue&type=script&lang=js"
export * from "./conError.vue?vue&type=script&lang=js"
import style0 from "./conError.vue?vue&type=style&index=0&id=1d451299&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d451299",
  null
  
)

export default component.exports